import { TextInput, SelectInput, required, useSimpleFormIteratorItem, maxLength } from "react-admin";
import { Grid } from "@mui/material";
import { useWatch } from "react-hook-form";
import { ExamCommitteeMemberTypeChoices } from "utils/choices";
import ProfessorInput from "./ProfessorInput";

const MemberFields = ({ watchPrefix = "", excludeIds = [] }) => {
  const employeeId = useWatch({ name: watchPrefix ? `${watchPrefix}.employeeId` : "employeeId" });
  const externalEmployeeNames = useWatch({
    name: watchPrefix ? `${watchPrefix}.externalEmployeeNames` : "externalEmployeeNames",
  });

  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        xs={12}
        md={4}
      >
        <SelectInput
          source="type"
          label="Тип"
          choices={ExamCommitteeMemberTypeChoices}
          validate={[required()]}
          fullWidth
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <ProfessorInput
          source="employeeId"
          label="Служител"
          fullWidth
          disabled={!!externalEmployeeNames}
          filters={excludeIds.length ? { ExcludeIds: excludeIds } : {}}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <TextInput
          source="externalEmployeeNames"
          label="Имена (външни)"
          fullWidth
          disabled={!!employeeId}
          validate={maxLength(300)}
        />
      </Grid>
    </Grid>
  );
};

export const MembersIteratorItem = ({ excludeIds = [], arraySource = "members" }) => {
  const { index } = useSimpleFormIteratorItem();
  const members = useWatch({ name: arraySource });

  const excludeEmployeeIds = [
    ...excludeIds,
    ...(members
      ?.filter((_, i) => i !== index)
      ?.map(m => m?.employeeId)
      ?.filter(Boolean) ?? []),
  ];

  return (
    <MemberFields
      watchPrefix={`${arraySource}.${index}`}
      excludeIds={excludeEmployeeIds}
    />
  );
};

export default MemberFields;
